//@ts-nocheck
import { Link, NavLink, useLocation } from "react-router-dom";
import Logo from "../assets/logo.svg";
import { Outlet } from "react-router";
import { useEffect, useState } from "react";
import ColorPicker from "../components/Reusable/ColorPicker";
import Logout from "./Logout";
import Modal from "../components/Reusable/Modal";
import SetupBranch from "./SetupBranch";
import APIS from "../constant/EndPoint";
import useGetHook from "../customHooks/useGetHook";
import useUserServiceGetHook from "../customHooks/useUserServiceGetHook";
import { Fragment } from 'react'
import { Dialog, Transition } from '@headlessui/react'
import { MenuAlt2Icon, XIcon } from '@heroicons/react/outline'
import { Popover } from '@headlessui/react'
import { navigation } from "./navigation"

import useNotificationGetHook from "../customHooks/useNotificationServiceGetHook";
import useWebsiteGetHook from "../customHooks/useWebsiteServiceGetHook"

import usePostHook from "../customHooks/useNotificationServicePostHook";



const DashboardLayout = () => {
  const [openColorPalate, setOpenColorPallet] = useState(false);
  const [openModal, setOpenModal] = useState(false);
  const [defaultColor, setDefaultColor] = useState("#EF0776");
  const location = useLocation();

  const { data: webisteInfo, isLoading } = useWebsiteGetHook({
    queryKey: [`webisteInfo`],
    url: APIS.WEBSITE_INFO,
    params: {},
  });
  useEffect(() => {
    if (webisteInfo) {
      document.title = webisteInfo?.title
      const link = document.querySelector('link[rel="icon"]');
      link?.setAttribute('href', webisteInfo?.favicon_icon);
    }
  }, [webisteInfo]);

  const { data: defaultBranch } = useGetHook({
    queryKey: [`default-branch`],
    url: `${APIS.DEFAULT_BRANCH}`,
    params: {},
  });

  const { data: profile } = useUserServiceGetHook({
    queryKey: [`profile`],
    url: `${APIS.USER}me/`,
    params: {},
  });

  const { data: notifications } = useNotificationGetHook({
    queryKey: [`notifications`],
    url: `${APIS.NOTIFICATION}`,
    params: {
      limit: 5,
      offset: 0,
      deleted: false,
      unread: true
    },
  });



  const handleThemeChange = (props: any) => {
    console.log(defaultColor);
    document
      .querySelector(":root")
      .style.setProperty("--primary", defaultColor);
    localStorage.setItem("primary-color", defaultColor);
    setOpenColorPallet(false);
  };

  useEffect(() => {
    let backgroundColor = localStorage.getItem("primary-color", defaultColor);
    if (!backgroundColor) {
      document
        .querySelector(":root")
        .style.setProperty("--primary", defaultColor);
      localStorage.setItem("primary-color", defaultColor);
    } else {
      document
        .querySelector(":root")
        .style.setProperty("--primary", backgroundColor);
    }
  });

  const [sidebarOpen, setSidebarOpen] = useState(false)

  const { mutateAsync } = usePostHook({
    queryKey: ["notifications"],
    navigateURL: "",
  });

  const handleReadAllNotification = async () => {
    const url = `${APIS.NOTIFICATION}read-all/`;
    let formData = {};
    try {
      await mutateAsync({ url, formData });
    } catch (err) {
      console.log(err);
    }
  }


  return (
    <>
      <div className="h-screen flex overflow-hidden bg-gray-100">
        <Transition.Root show={sidebarOpen} as={Fragment}>
          <Dialog
            as="div"
            static
            className="fixed inset-0 flex z-40 md:hidden"
            open={sidebarOpen}
            onClose={setSidebarOpen}
          >
            <Transition.Child
              as={Fragment}
              enter="transition-opacity ease-linear duration-300"
              enterFrom="opacity-0"
              enterTo="opacity-100"
              leave="transition-opacity ease-linear duration-300"
              leaveFrom="opacity-100"
              leaveTo="opacity-0"
            >
              <Dialog.Overlay className="fixed inset-0 bg-gray-600 bg-opacity-75" />
            </Transition.Child>
            <Transition.Child
              as={Fragment}
              enter="transition ease-in-out duration-300 transform"
              enterFrom="-translate-x-full"
              enterTo="translate-x-0"
              leave="transition ease-in-out duration-300 transform"
              leaveFrom="translate-x-0"
              leaveTo="-translate-x-full"
            >
              <div className="relative flex-1 flex flex-col max-w-xs w-full pb-2 bg-white">
                <Transition.Child
                  as={Fragment}
                  enter="ease-in-out duration-300"
                  enterFrom="opacity-0"
                  enterTo="opacity-100"
                  leave="ease-in-out duration-300"
                  leaveFrom="opacity-100"
                  leaveTo="opacity-0"
                >
                  <div className="absolute top-0 right-0 -mr-12 pt-2">
                    <button
                      type="button"
                      className="ml-1 flex items-center justify-center h-10 w-10 rounded-full focus:outline-none focus:ring-2 focus:ring-inset focus:ring-white"
                      onClick={() => setSidebarOpen(false)}
                    >
                      <span className="sr-only">Close sidebar</span>
                      <XIcon className="h-6 w-6 text-white" aria-hidden="true" />
                    </button>
                  </div>
                </Transition.Child>
                <div className="flex-shrink-0 flex items-center p-2 px-4 bg-primary">
                  {isLoading ? <div className="m-2 h-12" /> : <img
                    className="m-2 h-12 "
                    src={webisteInfo.logo ?? Logo}
                    alt="Workflow"
                  />}
                </div>
                <div className="flex-1 h-0 overflow-y-auto">
                  <nav className="flex-1 px-2" style={{
                    background:
                      "linear-gradient(135deg, rgba(239, 7, 118, 0.17) 0%, rgba(246, 172, 208, 0.03) 82.72%, rgba(248, 206, 226, 0.00) 100%)",
                  }}>
                    <ul>
                      {navigation?.map((item: any, index: number) => (
                        <li key={index}>
                          <span className="title pt-2 block font-[18px] mt-6 text-gray-500 font-metal">
                            {item.name}
                          </span>
                          {item.children.length && (
                            <>
                              <ul className="ml-2">
                                {item.children.map((subMenu: any, subIndex: number) => (
                                  <NavLink
                                    onClick={() => setSidebarOpen(false)}
                                    key={subIndex}
                                    to={subMenu.href}
                                    className={({ isActive, isPending }) =>
                                      `${isActive
                                        ? "bg-[#FFBBDC] rounded text-primary"
                                        : isPending
                                          ? "text-indigo-100 hover:bg-indigo-600"
                                          : ""
                                      } text-gray-700 my-1 cursor-pointer px-2 py-[4px] flex `
                                    }
                                  >
                                    <subMenu.icon
                                      color={
                                        location.pathname === subMenu.href
                                          ? "var(--primary)"
                                          : "gray"
                                      }
                                    />
                                    <span className="ml-4">{subMenu.name}</span>
                                  </NavLink>
                                ))}
                              </ul>
                            </>
                          )}
                        </li>
                      ))}
                    </ul>
                  </nav>
                </div>
              </div>
            </Transition.Child>
            <div className="flex-shrink-0 w-14" aria-hidden="true">
              {/* Dummy element to force sidebar to shrink to fit close icon */}
            </div>
          </Dialog>
        </Transition.Root>

        {/* Static sidebar for desktop */}
        <div className="hidden md:flex md:flex-shrink-0">
          <div className="flex flex-col w-64">
            {/* Sidebar component, swap this element with another sidebar if you like */}
            <div className="flex flex-col flex-grow pb-4 overflow-y-auto">
              <div className="flex items-center flex-shrink-0 bg-primary sticky top-0">
                {isLoading ? <div className="m-2 h-12" /> : <img
                  className="m-2 h-12 "
                  src={webisteInfo?.logo ?? Logo}
                  alt="Workflow"
                />}
              </div>
              <div className="flex-1 flex flex-col">
                <nav className="flex-1 px-2 space-y-1 m-2 rounded-xl" style={{
                  background:
                    "linear-gradient(135deg, rgba(239, 7, 118, 0.17) 0%, rgba(246, 172, 208, 0.03) 82.72%, rgba(248, 206, 226, 0.00) 100%)",
                }}>
                  <ul>
                    {navigation?.map((item: any, index: number) => (
                      <li key={index}>
                        <span className="title pt-2 block font-[18px] mt-6 text-gray-500 font-metal">
                          {item.name}
                        </span>
                        {item.children.length && (
                          <>
                            <ul className="ml-2">
                              {item.children.map((subMenu: any, subIndex: number) => (
                                <NavLink
                                  key={subIndex}
                                  to={subMenu.href}
                                  className={({ isActive, isPending }) =>
                                    `${isActive
                                      ? "bg-[#FFBBDC] rounded text-primary"
                                      : isPending
                                        ? "text-indigo-100 hover:bg-indigo-600"
                                        : ""
                                    } text-gray-700 my-1 cursor-pointer px-2 py-[4px] flex `
                                  }
                                >
                                  <subMenu.icon
                                    color={
                                      location.pathname === subMenu.href
                                        ? "var(--primary)"
                                        : "gray"
                                    }
                                  />
                                  <span className="ml-4">{subMenu.name}</span>
                                </NavLink>
                              ))}
                            </ul>
                          </>
                        )}
                      </li>
                    ))}
                  </ul>
                </nav>
              </div>
            </div>
          </div>
        </div>
        <div className="flex flex-col w-0 flex-1  overflow-hidden">
          <div className="relative z-10 flex-shrink-0 flex h-16 bg-white shadow">
            <button
              type="button"
              className="px-4 border-r border-gray-200 text-gray-500 focus:outline-none focus:ring-2 focus:ring-inset focus:ring-indigo-500 md:hidden"
              onClick={() => setSidebarOpen(true)}
            >
              <span className="sr-only">Open sidebar</span>
              <MenuAlt2Icon className="h-6 w-6" aria-hidden="true" />
            </button>
            <div className="flex-1 md:px-4 flex justify-between bg-primary">
              <div className="flex-1 flex">
                <form className="w-full flex md:ml-0" action="#" method="GET">
                  <label htmlFor="search-field" className="sr-only">
                    Search
                  </label>
                  <div className="relative w-full text-gray-400 focus-within:text-gray-600">
                    {/* <div className="absolute inset-y-0 left-0 flex items-center pointer-events-none">
                      <SearchIcon className="h-5 w-5" aria-hidden="true" />
                    </div> */}
                    {/* <input
                      id="search-field"
                      className="block w-full bg-primary text-wgite h-full pl-8 pr-3 py-2 border-transparent text-gray-900 placeholder-gray-500 focus:outline-none focus:placeholder-gray-400 focus:ring-0 focus:border-transparent sm:text-sm"
                      placeholder="Search"
                      type="search"
                      name="search"
                    /> */}
                  </div>
                </form>
              </div>
              <div className="flex items-center  md:ml-6">
                <header className="w-full  h-[60px] sticky top-0 text-white flex justify-end items-center px-2">
                  <div className="max-w-sm px-4">
                    <Popover className="relative">
                      {({ open }) => (
                        <>
                          <div className="absolute right-0 text-red-700 font-bold -top-1 px-2 bg-white rounded-full">{notifications?.count}</div>
                          <Popover.Button
                            className={`
                ${open ? 'text-white' : 'text-white/90'}
                group inline-flex items-center rounded-md  px-3 py-2 text-base font-medium hover:text-white focus:outline-none focus-visible:ring-2 focus-visible:ring-white/75`}
                          >
                            <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" strokeWidth="1.5" stroke="currentColor" className="w-6 h-6">
                              <path strokeLinecap="round" strokeLinejoin="round" d="M14.857 17.082a23.848 23.848 0 005.454-1.31A8.967 8.967 0 0118 9.75v-.7V9A6 6 0 006 9v.75a8.967 8.967 0 01-2.312 6.022c1.733.64 3.56 1.085 5.455 1.31m5.714 0a24.255 24.255 0 01-5.714 0m5.714 0a3 3 0 11-5.714 0" />
                            </svg>
                          </Popover.Button>
                          <Transition
                            as={Fragment}
                            enter="transition ease-out duration-200"
                            enterFrom="opacity-0 translate-y-1"
                            enterTo="opacity-100 translate-y-0"
                            leave="transition ease-in duration-150"
                            leaveFrom="opacity-100 translate-y-0"
                            leaveTo="opacity-0 translate-y-1"
                          >
                            <Popover.Panel className="absolute z-10 mt-3  max-w-sm w-[350px] -mx-[105px] md:mx-[-290px] px-4 sm:px-0">
                              <div className="overflow-hidden rounded-lg shadow-lg ring-1 ring-black/5 w-full">
                                <div className="relative grid gap-8 bg-white p-4">
                                  {notifications?.results?.map((item: any, index: number) => (
                                    <a
                                      key={index}
                                      href={"#"}
                                      className="-m-3 flex items-center rounded-lg p-2 transition duration-150 ease-in-out hover:bg-gray-50 focus:outline-none focus-visible:ring focus-visible:ring-orange-500/50"
                                    >
                                      <div className="ml-4">
                                        <p className="text-sm font-medium text-gray-900">
                                          {item?.title}
                                        </p>
                                        <p className="text-sm text-gray-500">
                                          {item?.description}
                                        </p>
                                      </div>
                                    </a>
                                  ))}
                                  <div className="relative bg-white text-black mx-4 w-full flex justify-center gap-x-6 cursor-pointer">
                                    <button onClick={handleReadAllNotification}>Read All</button> <Link to={"notification?limit=0&offset=0"}>View All</Link>
                                  </div>
                                </div>
                              </div>

                            </Popover.Panel>
                          </Transition>
                        </>
                      )}
                    </Popover>
                  </div>
                  {/* <button onClick={() => setOpenColorPallet(!openColorPalate)}>
              Change Theme
            </button> */}
                  <div>
                    <span className="text-[10px] mr-2 block text-right">
                      <span className="block capitalize">{profile?.full_name}</span>
                      <span className="block">{profile?.is_superuser ? "Super Admin" : "Staff"}</span>
                      <span className="block cursor-pointer" onClick={() => setOpenModal(profile?.is_superuser ? !openModal : false)}>{defaultBranch?.name?.length ? defaultBranch?.name : "N/A"}-{defaultBranch?.landmark?.length ? defaultBranch?.landmark : "N/A"}</span>
                    </span>
                  </div>
                  <div className="">
                    <Logout />
                    {/* <img
                src={UserIcon}
                alt="User Icon"
                className="w-[85%] cursor-pointer"
              /> */}
                  </div>
                </header>
              </div>
            </div>
          </div>

          <main className="flex-1 relative overflow-y-auto focus:outline-none">
            <div className="py-6">
              <div className="w-full mx-auto px-4 sm:px-6 md:px-8">
                <Outlet />
              </div>
            </div>
          </main>
        </div>
      </div>

      <ColorPicker
        isOpen={openColorPalate}
        setIsOpen={setOpenColorPallet}
        handleAccept={handleThemeChange}
        defaultColor={defaultColor}
        setDefaultColor={setDefaultColor}
      />
      <Modal
        isOpen={openModal}
        setIsOpen={setOpenModal}
        title={"Select Default Branch"}
        children={<SetupBranch
          setOpenModal={setOpenModal}
        />}
      />

    </>
  );
};

export default DashboardLayout;
